module.exports = __webpack_public_path__ + "img/GreekTechCatTriremeS_ua.d7dafe57.webp";